

























































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueElementLoading from 'vue-element-loading'
import Paginate from 'vuejs-paginate'
import DigitalPost from '../../../apiClient/DigitalPost'
import _ from 'lodash'
import swal from 'sweetalert2'
import BillboardMixin from '../../../mixins/BillboardMixin'
import moment, { updateLocale } from 'moment'

@Component({
  name: 'BillboardListHome',
  components: {
    VueElementLoading,
    paginate: Paginate
  }
})
export default class BillboardListHome extends Mixins(BillboardMixin) {
  public readonly POSTS_LIMIT = 4
  digitalPost: DigitalPost
  list: Array<any>
  total: number
  posts: any
  summary: Array<any>
  limit: number
  page: number
  loading: boolean
  show: boolean
  paginateDiv: HTMLElement
  message: string

  data() {
    return {
      list: [],
      page: 1,
      limit: 100,
      total: null,
      posts: null,
      summary: [],
      message: '',
      show: false,
      loading: false,
      spans: 0
    }
  }

  created() {
    this.digitalPost = new DigitalPost()
    this.fetchBillboard()
  }

  isValid(post: any): boolean {
    let dateTo = this.createDateObject(post.fecha_hasta)
    let dateFrom = this.createDateObject(post.fecha_desde)
    let dateNow = new Date()
    dateTo.setHours(0, 0, 0, 0)
    dateFrom.setHours(0, 0, 0, 0)
    dateNow.setHours(0, 0, 0, 0)

    return (
      dateNow.getTime() <= dateTo.getTime() &&
      dateNow.getTime() >= dateFrom.getTime()
    )
  }

  convert(str) {
    var date = new Date(str),
      mnth = ('0' + (date.getMonth() + 1)).slice(-2),
      day = ('0' + date.getDate()).slice(-2)
    return [date.getFullYear(), mnth, day].join('-')
  }

  async getPosts(limit?, page?) {
    try {
      this.show = true
      //sin filtro de estado; let {data:{data, total}} = await this.digitalPost.getAll(limit, (page -1));
      let {
        data: { data, total }
      } = await this.digitalPost.getAll(limit, page - 1, 1)
      //filtrar solo vigentes; this.list  = data.filter(a => this.isValid(a));
      this.list = data
      if (Array.isArray(this.list) && this.list.length) {
        this.$store.dispatch('setCarteleraHome', true)
      } else {
        this.$store.dispatch('setCarteleraHome', false)
      }

      this.total = Math.ceil(total / this.limit)
      this.show = false
    } catch (response) {
      this.$store.dispatch('setCarteleraHome', false)
      this.show = false
    }
  }

  reloadTable(page: number) {
    this.page = page
    this.getPosts(this.limit, this.page)
  }

  fetchBillboard() {
    this.getPosts(this.limit, 1)
  }

  *iterable() {
    yield* [...this.posts]
  }

  async fetchPosts() {
    this.summary = []
    let response = await this.digitalPost.getAll(4, 0, 1)
    this.summary = response.data.data
  }

  getDaysLeftNews(desde) {
    const fechaInicio = desde
    if (!fechaInicio) {
      return 0
    }
    const FORMAT = 'DD/MM/YYYY'
    const parseFechaInicio = moment(fechaInicio, FORMAT)
    const today = moment().startOf('day')
    const resultado = parseFechaInicio.diff(today, 'days')
    if (resultado < 0) {
      return 0
    }
    return resultado
  }
}
